import {useState, useEffect} from 'react';
import clsx from 'clsx';
import * as styles from './pagination.module.css';

interface IPaginationProps {
    activePage: number,
    goToPage: (page: number) => void,
    pageCount: number,
}

const Pagination = ({
    activePage = 1,
    goToPage,
    pageCount = 1,
}: IPaginationProps) => {
    const [pages, setPages] = useState<number[]>([]);
    const handlePageChange = (page: number) => goToPage(page);

    useEffect(() => {
        const arr = [];

        const start = (activePage - 2 > 0) ? activePage - 2 : 1;
        const end = (activePage + 2 < pageCount) ? activePage + 2 : pageCount;

        for (let i = start; i <= end; i++) {
            arr.push(i);
        }

        setPages(arr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageCount, activePage]);

    const buttons = pages.map((page, index) => (
        <button
            onClick={() => handlePageChange(page)}
            className={clsx(
                styles.buttons,
                page === activePage && styles.active,
                page === activePage - 1 && styles.leftToActive,
                page === activePage + 1 && styles.rightToActive,
            )}
            key={`pagination-btn-${index}`}
        >
            <span>{page}</span>
        </button>
    ));

    return (
        <div className={styles.root}>
            <div className={styles.buttonsBlock}>
                <button
                    onClick={() => handlePageChange(1)}
                    className={clsx(
                        styles.buttons,
                        styles.buttonFirst,
                        activePage - 3 <= 0 && styles.invisible,
                    )}
                >
                    <span>1</span>
                </button>
                <div className={styles.buttonsBlockSmall}>
                    {buttons}
                </div>
                <button
                    onClick={() => handlePageChange(pageCount)}
                    className={clsx(
                        styles.buttons,
                        styles.buttonLast,
                        activePage >= pageCount - 2 && styles.invisible,
                    )}
                >
                    <span>{pageCount}</span>
                </button>
            </div>
        </div>
    );
};

export default Pagination;
